/** Gets the local storage.  If the browser doesn't support local storage, it returns undefined. */
export function getLocalStorageItem(key: string) {
  let ls: Storage;
  try {
    ls = localStorage;
  } catch (e) {
    // Figma doesn't define localStorage or window
    return undefined;
  }
  try {
    return ls.getItem(key);
  } catch (e) {
    console.warn(`Error getting local storage item ${key}: ${e}`);
    return undefined;
  }
}

export function listenToStorageEvent(callback: (e: StorageEvent) => void) {
  let win: Window;
  try {
    win = window;
  } catch (e) {
    return;
  }
  if (win == null) return;
  win.addEventListener('storage', callback);
}
